import React, { useState, useContext, useRef } from "react";
import { getAPIUrl } from "../config";
import { useNavigate } from "react-router";
import UserContext from "../components/UserContext";
import { FaEye } from "react-icons/fa";
import "./Login.css";

// Toast notification component
const Toast = ({ message, type = "info" }) => {
  if (!message) return null;

  const toastStyle = {
    position: "fixed",
    top: "20px",
    right: "20px",
    padding: "15px 20px",
    borderRadius: "4px",
    color: "white",
    backgroundColor: type === "error" ? "#f44336" : "#4CAF50",
    boxShadow: "0 2px 10px rgba(0,0,0,0.1)",
    zIndex: 1000,
    animation: "slideIn 0.3s ease-out",
  };

  return <div style={toastStyle}>{message}</div>;
};

const goLogin = async (data) => {
  let response = await fetch(getAPIUrl() + `/users/authenticate`, {
    method: "POST",
    mode: "cors",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(data),
  });
  return response.json();
};

function Login() {
  const navigate = useNavigate();
  const userContext = useContext(UserContext);
  const usernameInput = useRef();
  const passwordInput = useRef();
  const [showPassword, setShowPassword] = useState(false);
  const [toast, setToast] = useState({ show: false, message: "", type: "info" });

  const showToast = (message, type = "info") => {
    setToast({ show: true, message, type });
    setTimeout(() => setToast({ show: false, message: "", type }), 3000);
  };

  const doLogin = async () => {
    const data = {
      username: usernameInput.current.value,
      password: passwordInput.current.value,
    };

    let result = await goLogin(data);

    if (result.res) {
      if (result.user && result.user.active === 0) {
        showToast("Your account is inactive. Please contact the administrator.", "error");
        return;
      }

      userContext.doLogin(result);
      showToast(result.msg || "Login successful", "success");

      setTimeout(() => {
        navigate("/home");
      }, 500);
    } else {
      showToast(result.msg || "Login failed. Please try again.", "error");
    }
  };

  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      event.preventDefault();
      doLogin();
    }
  };

  return (
    <div className="login-page">
      {toast.show && <Toast message={toast.message} type={toast.type} />}
      <div className="login-card">
        <div className="form-signin">
          <h2 className="form-signin-heading">SystemQ Monitor</h2>
        </div>
        <form className="form-signin">
          <div className="form-group">
            <label style={{ color: "#ffffff" }} htmlFor="username" className="form-label">
              Username
            </label>
            <input
              id="username"
              ref={usernameInput}
              placeholder="Enter your username"
              className="form-control"
              name="username"
              aria-label="Username"
            />
          </div>
          <div className="form-group" style={{ marginTop: "15px" }}>
            <label style={{ color: "#ffffff" }} htmlFor="password" className="form-label">
              Password
            </label>
            <div style={{ position: 'relative' }}>
              <input
                type={showPassword ? "text" : "password"}
                id="password"
                ref={passwordInput}
                placeholder="Enter your password"
                className="form-control"
                onKeyDown={handleKeyDown}
                style={{ paddingRight: '40px' }}
              />
              <FaEye
                style={{
                  position: 'absolute',
                  right: '10px',
                  top: '50%',
                  transform: 'translateY(-50%)',
                  cursor: 'pointer',
                  color: showPassword ? '#007bff' : '#6c757d',
                }}
                onClick={() => setShowPassword(!showPassword)}
                title={showPassword ? 'Hide password' : 'Show password'}
              />
            </div>
          </div>
          <input
            type="button"
            className="btn btn-lg btn-outline-light btn-block"
            onClick={doLogin}
            value="Login"
          />
        </form>
      </div>
    </div>
  );
}

export default Login;
